import { createObjectCsvStringifier } from 'csv-writer';

export const convertTableToCSV = (
  headers: { id: string; display_name: string; type?: string }[],
  data: Record<string, unknown>[],
): string => {
  const csvHeaders = headers.map((h) => ({
    id: h.id,
    title: h.display_name,
  }));

  const stringifier = createObjectCsvStringifier({
    header: csvHeaders,
  });

  return stringifier.getHeaderString() + stringifier.stringifyRecords(data);
};

export const downloadCSV = (csvContent: string, filename: string) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  window.URL.revokeObjectURL(url);
};

export const extractHeadersFromTableData = (
  tableData: { headers: { id: string; display_name: string; type?: string }[] },
  tableRows: any[],
) =>
  tableData?.headers ??
  Array.from(
    new Set(
      tableRows.reduce(
        (acc: string[], item: any) => [...acc, ...Object.keys(item || {})],
        [],
      ),
    ),
  ).map((key: string) => ({ id: key, display_name: key }));
